import { TFileToUpload } from '~/types/file-upload.types';
import { v4 as uuidv4 } from 'uuid';
import { IImage, IUploadQuestionAsset } from '~/types/model.types';
import { TQuestionAttachment } from '~/common/UploadQuestion/upload-question.types';
import { IS3UploadFileResponse } from '~/types/server.types';

export const convertToFileToUpload = (file: File): TFileToUpload => {
    const formattedFile = <TFileToUpload>file;
    formattedFile._id = uuidv4();
    formattedFile.dataUrl = '';
    return formattedFile;
};

export const filesToAttachmentsToUpload = (
    files: TFileToUpload[]
): TQuestionAttachment[] => {
    return files.map(file => ({
        ...file,
        url: '',
        name: file.name,
        type: file.type.includes('image') ? 'image' : 'file',
        uploadProgress: 1
    }));
};

export const convertImageToAttachment = (
    image: IImage
): TQuestionAttachment => {
    return {
        _id: image.internalId,
        name: image.filename,
        url: image.url,
        type: 'image',
        uploadProgress: undefined
    };
};

export const convertUploadedFileToAttachment = (
    uploadedFile: IS3UploadFileResponse
): TQuestionAttachment => {
    return {
        _id: uploadedFile.internalId,
        name: uploadedFile.file_name,
        url: uploadedFile.data
            ? uploadedFile.data.match(/<Location>([\s\S]*?)<\/Location>/)[1]
            : '',
        type: 'file',
        uploadProgress: undefined
    };
};

export const variableValueToAttachments = (
    assets: IUploadQuestionAsset[]
): TQuestionAttachment[] => {
    return (
        assets?.map(asset => {
            return {
                _id: asset._id,
                name: asset.asset_name,
                url: asset.url,
                type: asset.asset_type
            };
        }) || []
    );
};

export const attachmentsToVariableValue = (
    attachments: TQuestionAttachment[]
): Partial<IUploadQuestionAsset>[] => {
    return (
        attachments?.map(attachment => {
            return {
                _id: attachment._id,
                asset_name: attachment.name,
                url: attachment.url,
                asset_type: attachment.type
            };
        }) || []
    );
};

export function handleUploadedFile(
    uploadedItem: IImage | any,
    currentAttachments: TQuestionAttachment[]
): TQuestionAttachment[] {
    const _newAttachment = uploadedItem.cloudinary_public_id
        ? convertImageToAttachment(uploadedItem)
        : convertUploadedFileToAttachment(uploadedItem);

    return currentAttachments.map(attachment => {
        return attachment._id === uploadedItem.internalId
            ? _newAttachment
            : attachment;
    });
}
